export function moveIdWithinList(ids: string[], activeId: string, overId: string): string[] {
  const from = ids.indexOf(activeId);
  const to = ids.indexOf(overId);
  if (from < 0 || to < 0 || from === to) return ids;
  const reordered = [...ids];
  const [item] = reordered.splice(from, 1);
  if (item === undefined) return ids;
  reordered.splice(to, 0, item);
  return reordered;
}
